import React from 'react';
import { CircleLoader } from 'react-spinners';

const CircleLoad = () => (
  <div className="w-100 d-flex flex-column justify-content-center align-items-center mb-3">
    <CircleLoader color={'#00A587'} size={90} />
  </div>
);

export default CircleLoad;
